/** 协会后台 · 供需管理（页面固定文案） */
export default {
  pageTitle: '供需管理',
  tabList: '供需列表',
  tabCategories: '供需分类',
  tabSettings: '商圈配置',

  searchPlaceholder: '搜索标题/内容/分类',
  searchCategoryPlaceholder: '搜索',
  filterAll: '全部',
  filterShow: '显示',
  filterHide: '隐藏',
  add: '添加',
  refresh: '刷新',
  emptyList: '没有找到匹配的记录',
  emptyCategories: '暂无分类',
  paginationRange: '显示第 {from} 到第 {to} 条记录，总共 {total} 条记录',

  colId: 'Id',
  colCategoryName: '分类名称',
  colPublisherName: '发布人名称',
  colTitle: '标题',
  colCreatedAt: '创建时间',
  colUpdatedAt: '更新时间',
  colSortOrder: '权重',
  colDisplayStatus: '显示状态',
  colAuditStatus: '审核状态',
  colStatus: '状态',
  colActions: '操作',
  colCategoryId: 'ID',
  colSort: '排序',
  statusShow: '显示',
  statusHide: '隐藏',
  auditPending: '待审核',
  auditApproved: '已通过',
  auditRejected: '已驳回',
  btnAudit: '审核',
  btnApprove: '通过',
  btnReject: '驳回',
  dialogAudit: '审核供需',
  fieldRejectReason: '驳回原因',
  fieldRejectReasonPlaceholder: '驳回时请填写原因',
  ruleRejectReasonRequired: '请填写驳回原因',
  auditSaved: '审核已保存',

  dialogAdd: '添加',
  dialogEdit: '编辑',
  fieldCategory: '选择分类',
  fieldCategoryPlaceholder: '请选择分类',
  fieldPublisher: '发布人名称',
  fieldPublisherPlatform: '平台',
  fieldPublisherNote1: '备注：',
  fieldPublisherNote2: '1.如果平台发布，默认显示商协信息和电话；',
  fieldPublisherNote3: '2.如果会员发布，默认显示会员信息和电话；',
  fieldTitle: '标题',
  fieldContent: '内容',
  fieldAddress: '地址',
  fieldAddressPlaceholder: '请输入地址',
  fieldImages: '图片',
  fieldImagesUpload: '上传',
  fieldImagesHint: '最多 9 张，支持 jpg / png / webp',
  auditNoImages: '暂无图片',
  fieldWeight: '权重',
  fieldStatus: '状态',
  fieldCategoryName: '分类名称',
  fieldCategoryNamePlaceholder: '请输入分类名称',
  fieldSort: '排序',
  confirm: '确定',

  settingsVisibility: '对外状态：',
  visibilityOpen: '全部开放',
  visibilityPartial: '部分开放',
  visibilityMember: '会员专属(只有会员才能查看)',
  settingsNotesTitle: '备注：',
  settingsNote1: '1.全部开放：所有信息对外开放，可进入商圈列表和详情页；',
  settingsNote2: '2.部分开放：可查看商圈列表；进入详情与拨打电话需成为会员；',
  settingsNote3: '3.会员专属：只有入会成功的商会会员才能查看商圈信息。',
  settingsAudit: '商圈审核：',
  auditYes: '是',
  auditNo: '否',

  tip: '提示',
  deleteDemandConfirm: '确认删除「{title}」？',
  deleteCategoryConfirm: '确认删除分类「{name}」？',
  loadFailed: '加载失败',
  loadSettingsFailed: '加载配置失败',
  saveFailed: '保存失败',
  deleteFailed: '删除失败',
  uploadFailed: '上传失败',
  imageUploaded: '图片已上传',
  created: '已创建',
  updated: '已更新',
  deleted: '已删除',
  categoryCreated: '分类已创建',
  categoryUpdated: '分类已更新',
  settingsSaved: '商圈配置已保存',

  ruleCategoryRequired: '请选择分类',
  ruleTitleRequired: '请输入标题',
  ruleStatusRequired: '请选择状态',
  ruleCategoryNameRequired: '请输入分类名称',

  memberFallback: '会员#{id}'
}
